/* ADAPTED FROM https://github.com/langfordG/react-chord-diagram
MIT License

Copyright (c) 2017 Grayson Langford

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
SOFTWARE.
*/
import React, { useState } from "react";
import { arc } from "d3-shape";
import { ribbon, chord } from "d3-chord";
import { scaleOrdinal } from "d3-scale";
import { range, descending } from "d3-array";
import Svg from "components/ChordDiagram/Svg";
import Groups from "components/ChordDiagram/Groups";
import Ribbons from "components/ChordDiagram/Ribbons";
import "./main.module.css";
const DEFAULT_PROPS = {
    //matrix: [],
    componentId: 1,
    width: 700,
    height: 700,
    //style: {},
    className: "",
    outerRadius: null,
    innerRadius: null,
    //groupLabels: [],
    //groupColors: [],
    padAngle: 0.05,
    sortGroups: null,
    sortSubgroups: descending,
    sortChords: null,
    labelColors: ["#000000"],
    disableHover: false,
    disableGroupHover: false,
    disableRibbonHover: true,
    strokeWidth: 1,
    resizeWithWindow: false,
    blurOnHover: false,
    ribbonOpacity: "0.67",
    ribbonBlurOpacity: "0.2",
    ribbonHoverOpacity: "0.2",
    persistHoverOnClick: false
};
const ChordDiagram = (rawProps) => {
    const props = {
        ...DEFAULT_PROPS,
        ...rawProps
    };
    const { matrix, componentId, width, height, style, className, groupLabels, groupLabelsFull, groupColors, groupOnClick, padAngle, sortGroups, sortSubgroups, sortChords, labelColors, disableHover, disableGroupHover, disableRibbonHover, strokeWidth, resizeWithWindow, ribbonOnClick, blurOnHover, ribbonOpacity, ribbonBlurOpacity, persistHoverOnClick, svgOnClick, hoverNode, hoverGroup, hoverRibbon } = props;
    const [mouseOverGroup, setMouseOverGroup] = useState(hoverGroup);
    const [mouseOverRibbon, setMouseOverRibbon] = useState(hoverRibbon);
    const [hoverPersist, setHoverPersist] = useState(persistHoverOnClick);
    const clearHover = () => {
        setHoverPersist(false);
        setMouseOverGroup(undefined);
        setMouseOverRibbon(undefined);
    };
    const outerRadius = props.outerRadius || Math.min(width, height) * 0.5 - 40;
    const innerRadius = props.innerRadius || outerRadius - 30;
    const d3Chord = chord().padAngle(padAngle).sortGroups(sortGroups).sortSubgroups(sortSubgroups).sortChords(sortChords);
    const chords = d3Chord(matrix);
    const d3Arc = arc().innerRadius(innerRadius).outerRadius(outerRadius);
    const d3Ribbon = ribbon().radius(innerRadius);
    const color = scaleOrdinal(range(groupColors.length), groupColors);
    return (React.createElement(Svg, { width: width, height: height, style: style, className: className, clearHover: clearHover, resizeWithWindow: resizeWithWindow, onClick: svgOnClick },
        React.createElement(Ribbons, { chords: chords, color: color, disableHover: disableHover || disableRibbonHover, ribbon: d3Ribbon, setMouseOverRibbon: setMouseOverRibbon, mouseOverGroup: mouseOverGroup, mouseOverRibbon: mouseOverRibbon, strokeWidth: strokeWidth, hoverPersist: hoverPersist, setHoverPersist: setHoverPersist, onClick: ribbonOnClick, hoverNode: hoverNode, blurOnHover: blurOnHover, ribbonOpacity: ribbonOpacity, ribbonBlurOpacity: ribbonBlurOpacity }),
        React.createElement(Groups, { componentId: componentId, chords: chords, color: color, arc: d3Arc, outerRadius: outerRadius, mouseOverGroup: mouseOverGroup, setMouseOverGroup: setMouseOverGroup, groupLabels: groupLabels, groupLabelsFull: groupLabelsFull, labelColors: labelColors, disableHover: disableHover || disableGroupHover, hoverPersist: hoverPersist, setHoverPersist: setHoverPersist, onClick: groupOnClick })));
};
export default ChordDiagram;
